"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostScoreBodyFoundationSchema = void 0;
const zod_1 = require("../../../utils/zod");
const zod_2 = __importDefault(require("zod"));
const zod_3 = require("../../../utils/zod");
/**
 * Foundation schema for all score types. Used for ingestion and public API. Supports trace, observation and session scores.
 * Needs to be extended with with score data specific schema (numeric, categorical, boolean)
 * @see {@link NumericData}, {@link CategoricalData}, {@link BooleanData}
 */
exports.PostScoreBodyFoundationSchema = zod_2.default.object({
    id: zod_2.default.string().nullish(),
    name: zod_3.NonEmptyString,
    traceId: zod_2.default.string().nullish(),
    sessionId: zod_2.default.string().nullish(),
    datasetRunId: zod_2.default.string().nullish(),
    observationId: zod_2.default.string().nullish(),
    comment: zod_2.default.string().nullish(),
    metadata: zod_1.jsonSchema.nullish(),
    environment: zod_2.default.string().default("default"),
    queueId: zod_2.default.string().nullish(),
});
